import React, { useCallback, useContext } from 'react';

import {
  ActionBar,
  Actions,
  Action,
  SellOutlinedIcon,
  Typography,
  DownloadIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useParams, useScreenState } from '@gogame/screens';

import SwitchViewMode from 'scenes/Gallery/components/SwitchViewMode';

import { useExportConversionPages } from 'scenes/Gallery/ConversionPages/ConversionPages/data';
import { ConversionPagesDataTableContext } from 'scenes/Gallery/ConversionPages/ConversionPages/ConversionPagesDataTable';
import Tags from 'scenes/Gallery/ConversionPages/ConversionPages/Tags';
import { VIEW_MODE_TILES } from 'scenes/Gallery/ConversionPages/constants';

import OrderControl from './OrderControl';

const Toolbar = ({ tabs, withTitle }) => {
  const { filters, searchQuery } = useScreenState();
  const params = useParams();

  const { viewMode, setViewMode, data, tableSettings } = useContext(
    ConversionPagesDataTableContext
  );

  const [childComponent, openChildComponent] = useChildComponent();

  const handleViewTags = () => {
    openChildComponent(Tags);
  };

  const [exportPages] = useExportConversionPages();

  const handleExportPages = useCallback(() => {
    return exportPages({
      tableSettings,
      filters,
      groupId: params?.groupId,
      searchQuery,
    });
  }, [exportPages]);

  return (
    <>
      <ActionBar
        search={<SearchField tooltip={'Search by id, name or tag'} />}
        secondaryActions={
          <Actions>
            {viewMode === VIEW_MODE_TILES ? (
              <Action custom={<OrderControl />} />
            ) : null}
            <Action
              icon={<DownloadIcon />}
              label={'Download'}
              tooltip={'Download'}
              onClick={handleExportPages}
            />
            <Action component={FullScreenToggler} />
          </Actions>
        }
        primaryActions={
          <Actions>
            <Action
              icon={<SellOutlinedIcon />}
              tooltip={'View Tags'}
              variant={'outlined'}
              onClick={handleViewTags}
            />
          </Actions>
        }
        modeSwitcher={
          <Actions>
            <Action
              custom={
                <SwitchViewMode viewMode={viewMode} setViewMode={setViewMode} />
              }
            />
          </Actions>
        }
      >
        {withTitle ? (
          <Typography variant={'subtitle1'}>
            Conversion Pages {data?.count ? `(${data.count})` : ''}
          </Typography>
        ) : (
          tabs
        )}
      </ActionBar>
      {childComponent}
    </>
  );
};

export default Toolbar;
